import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { ConversationsState, SLICE_NAME } from './models';

const conversationsSelector = (state: RootState): ConversationsState => state[SLICE_NAME];

export const selectConversations = createSelector(
  conversationsSelector,
  (state: ConversationsState) => state.conversations,
);

export const selectConversationsIsLoading = createSelector(
  conversationsSelector,
  (state: ConversationsState) => state.isLoading,
);

export const selectConversationsError = createSelector(
  conversationsSelector,
  (state: ConversationsState) => state.error,
);

export const selectConversationsPagination = createSelector(
  conversationsSelector,
  (state: ConversationsState) => state.pagination,
);
